import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    borderBottom: '1px solid #ddd',
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
